// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_pOA","cls2":"FocusedNav-cls2_Rz9 FocusedNav-cls1_pOA"};